import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { TextField } from '@johnlewispartnership/wtr-ingredients/dist/Forms';
import { SIMPLE_QUESTION } from '../../../../components/CompetitionsForms/constants';
import styles from '../../CompetitionsForm.module.scss';
const SimpleQuestion = ({ form: { errors, register }, competitionQuestion }) => {
    var _a;
    if (!competitionQuestion) {
        return null;
    }
    return (React.createElement("div", { className: classNames(styles.spacerLarge, styles.sectionWrapper, styles.sectionTopSpacer) },
        React.createElement("div", { className: styles.spacer },
            React.createElement(Typography, { id: "simpleQuestion", styleAs: "paragraph", element: "p" }, competitionQuestion)),
        React.createElement(TextField, { errorText: (_a = errors.competitionAnswer) === null || _a === void 0 ? void 0 : _a.message, id: "competition-question", label: "Answer", name: "competitionAnswer", ref: register(SIMPLE_QUESTION) })));
};
SimpleQuestion.defaultProps = {
    competitionQuestion: undefined,
};
SimpleQuestion.propTypes = {
    competitionQuestion: propTypes.string,
    form: propTypes.shape({
        errors: propTypes.shape({
            answer: propTypes.shape({ type: propTypes.string, message: propTypes.string }),
            competitionAnswer: propTypes.shape({ type: propTypes.string, message: propTypes.string }),
        }).isRequired,
        register: propTypes.func.isRequired,
    }).isRequired,
};
export default SimpleQuestion;
//# sourceMappingURL=index.js.map